// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"744":"translation-en-error-json","797":"translation-en-login-json"}[chunkId] + "." + {"744":"cec495c80f0d685b5688","797":"9e3374ae9939684b9684"}[chunkId] + ".chunk.js";
};